import { Navigate, type RouteObject } from "react-router";
import ApiKey from "./[customerId]/api-key/api-key";
import ContactRoute from "./[customerId]/contacts/contact";
import { CustomerRoute } from "./[customerId]/customer-route";
import { DeliveryTemplates } from "./[customerId]/delivery-templates/delivery-templates";
import { CustomersIndexRoute } from "./_components/customers-index-route";

export const customersRoutes: RouteObject[] = [
  {
    index: true,
    element: <CustomersIndexRoute />,
  },
  {
    path: ":customerId",
    element: <CustomerRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="contacts" />,
      },
      {
        path: "contacts",
        index: true,
        element: <ContactRoute />,
      },
      {
        path: "api-key",
        element: <ApiKey />,
      },
      {
        path: "templates",
        element: <DeliveryTemplates />,
      },
    ],
  },
];
